import { api } from '../..';
import { WorldCupReportData, WorldCupReportListData } from './types';

export const worldCupReportsApi = api.enhanceEndpoints({ addTagTypes: ['WorldCupReports'] }).injectEndpoints({
  endpoints: build => ({
    exportParticipationsReport: build.query<
      WorldCupReportData,
      { fromDate: string; toDate: string; format: string }
    >({
      query: ({ fromDate, toDate, format }) => ({
        url: `v1/promotions/admin/report/participations?fromDate=${fromDate}&toDate=${toDate}&format=${format}`,
        method: 'GET',
      }),
    }),
    exportPrizesReport: build.query<
      WorldCupReportData,
      { fromDate: string; toDate: string; format: string }
    >({
      query: ({ fromDate, toDate, format }) => ({
        url: `v1/promotions/admin/report/prizes?fromDate=${fromDate}&toDate=${toDate}&format=${format}`,
        method: 'GET',
      }),
    }),
    exportPrizeDrawsReport: build.query<
      WorldCupReportData,
      { fromDate: string; toDate: string; format: string }
    >({
      query: ({ fromDate, toDate, format }) => ({
        url: `v1/promotions/admin/report/prize-draws?fromDate=${fromDate}&toDate=${toDate}&format=${format}`,
        method: 'GET',
      }),
    }),
    getWorldCupReportList: build.query<WorldCupReportListData, any>({
      query: () => ({
        url: `v1/promotions/admin/report`,
        method: 'GET',
      }),
    }),
    downloadWorldCupReport: build.query<Blob, { filename: string }>({
      query: ({ filename }) => ({
        url: `v1/promotions/admin/report/download/${filename}`,
        method: 'GET',
        responseHandler: response => response.blob(),
      }),
    }),
    downloadRaffleRoundsReport: build.query<Blob, { raffleConfigId: number; verbose?: 'en' | 'es' }>({
      query: ({ raffleConfigId, verbose = 'en' }) => ({
        url: `v1/promotions/admin/reports/raffle-rounds?raffleConfigId=${raffleConfigId}&verbose=${verbose}`,
        method: 'GET',
        responseHandler: response => response.blob(),
      }),
    }),
    downloadParticipantsReport: build.query<
      Blob,
      { campaignId: number; verbose?: 'en' | 'es'; phone?: string; dateFrom?: string; dateTo?: string }
    >({
      query: ({ campaignId, verbose = 'en', phone, dateFrom, dateTo }) => {
        const params = new URLSearchParams({ campaignId: String(campaignId), verbose });
        if (phone) params.append('phone', phone);
        if (dateFrom) params.append('dateFrom', dateFrom);
        if (dateTo) params.append('dateTo', dateTo);
        return {
          url: `v1/promotions/admin/reports/participants?${params.toString()}`,
          method: 'GET',
          responseHandler: response => response.blob(),
        };
      },
    }),
  }),
});

export const {
  useLazyExportParticipationsReportQuery,
  useLazyExportPrizesReportQuery,
  useLazyExportPrizeDrawsReportQuery,
  useLazyGetWorldCupReportListQuery,
  useLazyDownloadWorldCupReportQuery,
  useLazyDownloadRaffleRoundsReportQuery,
  useLazyDownloadParticipantsReportQuery,
} = worldCupReportsApi;
